const Skill = ({ title }) => {
  return (
    <span className='inline-flex items-center px-4 py-2 rounded-full border border-ink/12 bg-white text-ink/80 font-medium text-sm md:text-base transition-all duration-300 hover:border-accent hover:text-accent hover:-translate-y-0.5 hover:shadow-[0_8px_16px_-8px_rgba(67,56,202,0.35)]'>
      {title}
    </span>
  );
};

export default Skill;
